var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGtv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.936,
    height: 26.03,
    viewBox: "0 0 30.936 26.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5881",
    "data-name": "Group 5881",
    transform: "translate(6524.009 1730.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17999",
    "data-name": "Path 17999",
    d: "M94.548,386.361l-.316-7.591c0-.016-.005-.036-.005-.052V378.7l-.026-.654a.233.233,0,0,0-.233-.218h-.005l-4.582.192a.227.227,0,0,0-.218.239l.373,8.92a.221.221,0,0,0,.239.218l4.577-.192a.212.212,0,0,0,.161-.073.236.236,0,0,0,.062-.166l-.026-.576Z",
    transform: "translate(-6613.171 -2092.928)",
    fill: "#6d44e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18000",
    "data-name": "Path 18000",
    d: "M209.057,396.907c-1.977-1.982-3.264-1.375-3.326-1.349l-1.775.711h-.005l-.041.016c0,.005-.005.005-.01.005l-4.457,1.78a1.755,1.755,0,0,1-1.292.649l-7.685.322h-.021a.265.265,0,0,1-.01-.529l7.69-.322a1.239,1.239,0,1,0-.1-2.475l-4.364.182a.27.27,0,0,1-.223-.1c-.96-1.256-2.963-1.738-4.068-1.909a6.87,6.87,0,0,0-1.36-.073l-4.26.177.306,7.207,9.521,2.294a7.192,7.192,0,0,0,1.889.161,7.455,7.455,0,0,0,3.295-.929l10.274-5.677a.089.089,0,0,0,.041-.062.114.114,0,0,0-.021-.072Z",
    transform: "translate(-6702.15 -2107.953)",
    fill: "#6d44e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18001",
    "data-name": "Path 18001",
    d: "M303.094,248.932a10.583,10.583,0,0,0-7.083-4.115c-.254-.026-.5-.041-.752-.052a13.542,13.542,0,0,1,2.382-5.7,2.577,2.577,0,0,1-.374-.379,13.57,13.57,0,0,0-2.143,4.286,13.155,13.155,0,0,0-1.8-5.417,2.64,2.64,0,0,1-.41.348,13.3,13.3,0,0,1,1.8,6.865,8.78,8.78,0,0,0-5,1.712,6.752,6.752,0,0,1,3.741,1.889l4.229-.177a1.772,1.772,0,0,1,1.842,1.691,1.819,1.819,0,0,1-.047.483Z",
    transform: "translate(-6801.828 -1960.975)",
    fill: "#6d44e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18002",
    "data-name": "Path 18002",
    d: "M235.594,128a3.415,3.415,0,0,0,3.549.208,2.916,2.916,0,0,0,.654-.379,12.754,12.754,0,0,0-3.373-3.388.266.266,0,0,1,.306-.436,13.412,13.412,0,0,1,3.466,3.466,2.572,2.572,0,0,0,.534-.841,3.978,3.978,0,0,0,.265-1.323,3.387,3.387,0,0,0-1.614-3.015,12.5,12.5,0,0,0-5.765-1.276c-.3,3.248.431,5.848,1.977,6.984Z",
    transform: "translate(-6748.997 -1851.344)",
    fill: "#6d44e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18003",
    "data-name": "Path 18003",
    d: "M412.63,153.656a3.985,3.985,0,0,0,.145,1.344,2.5,2.5,0,0,0,.451.882A13.166,13.166,0,0,1,417,152.753a.265.265,0,0,1,.27.457,12.457,12.457,0,0,0-3.669,3.061,2.941,2.941,0,0,0,.618.436,3.422,3.422,0,0,0,3.554.125c1.64-.986,2.6-3.513,2.6-6.776-.285-.026-.825-.067-1.489-.067a10.438,10.438,0,0,0-4.364.815,3.383,3.383,0,0,0-1.894,2.853Z",
    transform: "translate(-6917.451 -1878.597)",
    fill: "#6d44e5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGtv);
export default __webpack_public_path__ + "static/media/gtv.6071bc5b4390b27eebb14ec7b4237f6f.svg";
export { ForwardRef as ReactComponent };